var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player"},[_c('p',[_vm._v("Player: "+_vm._s(_vm.playerScore))]),_c('div',{staticClass:"display"},_vm._l((_vm.playerCards),function(card,index){return _c('div',{key:index},[_c('img',{attrs:{"src":card.image,"alt":"player card"}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }